import axios from 'axios';
import { retrieve } from '../Services/localStorageService';
import { handleLogout } from './logoutHandler';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = retrieve('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 433) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

export default apiClient;